import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import Assignment from '@mui/icons-material/Assignment';
import OfferAssetGeneralDetailsComponent from './OfferAssetGeneralDetailsComponent';
import OfferAssetGeneralDetailsSummary from './OfferAssetGeneralDetailsSummary';
import { CollapseCard } from '@totalsoft/rocket-ui';

const OfferAssetGeneralCard = ({
  generalData,
  t,
  sources,
  channels,
  partnerPriorities,
  savingGeneralData,
  isDirty,
  updateGeneralData,
  onSave,
  offerTypes,
  isFacilityFrame,
  processing,
  asmResponsibleOptions,
  responsibleOptions,
  workLocations,
  dealers,
  userInfo,
  validationInfo
}) => {
  const [expanded, setExtended] = useState(false);

  const toggleExpanded = useCallback(() => {
    setExtended(prev => !prev);
  }, []);

  return (
    <CollapseCard
      id={'offerAssetGeneralCard'}
      icon={Assignment}
      title={t('OfferEdit.Asset.GeneralDetails.Title')}
      expanded={expanded}
      onToggle={toggleExpanded}
      toggleOnHeaderClick
      subheader={<OfferAssetGeneralDetailsSummary generalData={generalData} />}
      hideSubheaderOnExpand
    >
      {generalData && (
        <OfferAssetGeneralDetailsComponent
          generalData={generalData}
          onGeneralDetailsChange={updateGeneralData}
          onSave={onSave}
          sources={sources}
          channels={channels}
          partnerPriorities={partnerPriorities}
          savingGeneralData={savingGeneralData}
          isDirty={isDirty}
          offerTypes={offerTypes}
          processing={processing}
          isFacilityFrame={isFacilityFrame}
          asmResponsibleOptions={asmResponsibleOptions}
          responsibleOptions={responsibleOptions}
          workLocations={workLocations}
          dealers={dealers}
          userInfo={userInfo}
          validationInfo={validationInfo}
        />
      )}
    </CollapseCard>
  );
};

OfferAssetGeneralCard.propTypes = {
  generalData: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  sources: PropTypes.array.isRequired,
  channels: PropTypes.array.isRequired,
  asmResponsibleOptions: PropTypes.array.isRequired,
  partnerPriorities: PropTypes.array.isRequired,
  savingGeneralData: PropTypes.bool,
  isDirty: PropTypes.bool.isRequired,
  updateGeneralData: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  viewType: PropTypes.string.isRequired,
  isFacilityFrame: PropTypes.bool,
  offerTypes: PropTypes.array.isRequired,
  responsibleOptions: PropTypes.array.isRequired,
  processing: PropTypes.bool,
  workLocations: PropTypes.array.isRequired,
  dealers: PropTypes.array.isRequired,
  userInfo: PropTypes.object.isRequired,
  validationInfo: PropTypes.object
};

export default withTranslation()(OfferAssetGeneralCard);
